import React from "react";
import teacherImg from "../Assests/cropped_circle_image (1).png";
import studentImg from "../Assests/cropped_circle_image.png";

const Hero = () => {
  return (
    <div className="relative overflow-hidden bg-gradient-to-br from-sky-50 via-purple-50 to-pink-50 pt-16 pb-32">
      {/* Glow blobs */}
      <div className="pointer-events-none absolute -top-24 -left-32 h-72 w-72 rounded-full bg-purple-300/40 blur-3xl" />
      <div className="pointer-events-none absolute -bottom-32 -right-10 h-80 w-80 rounded-full bg-blue-300/40 blur-3xl" />

      <div className="relative max-w-7xl mx-auto px-6 lg:px-10 grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
        {/* LEFT TEXT */}
        <div className="space-y-6">
          <span className="inline-flex items-center gap-2 rounded-full bg-white/70 backdrop-blur-md px-3 py-1 text-xs font-semibold text-blue-700 shadow-sm border border-white/60 animate-[fadeIn_0.5s_ease-out]">
            🎓 Yeole Coaching Classes · Maharashtra
          </span>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-gray-900 leading-tight tracking-tight">
            Maharashtra&apos;s{" "}
            <span className="bg-gradient-to-r from-blue-600 via-purple-600 to-pink-500 bg-clip-text text-transparent">
              Trusted & Affordable
            </span>
            <br />
            Educational Platform
          </h1>

          <p className="text-gray-600 text-lg max-w-xl">
           Unlock your potential with the most affordable learning solution.
            Start learning with India's top educators today!
          </p>

          {/* CTA buttons */}
          <div className="flex flex-col sm:flex-row gap-4 pt-2">
            <button className="inline-flex justify-center items-center gap-2 bg-gradient-to-r from-blue-600 to-purple-600 text-white px-8 py-3 rounded-xl text-lg font-semibold shadow-lg shadow-purple-400/40 hover:scale-105 hover:shadow-xl transition-transform duration-200">
              Get Started
            </button>
          </div>

        </div>

       


{/* RIGHT IMAGES + GLASS CARD (optimized for mobile) */}
<div className="relative flex justify-center lg:justify-end mt-6 lg:mt-0">
  <div className="relative w-full max-w-xs sm:max-w-sm md:max-w-md lg:max-w-lg">
    {/* Glass background with enhanced glow */}
    <div className="absolute inset-0 rounded-3xl bg-gradient-to-br from-white/80 to-purple-50/70 backdrop-blur-xl border border-white/90 shadow-2xl shadow-purple-300/50 -z-10" />
    
    {/* Decorative floating elements */}
    <div className="absolute -top-3 -left-3 w-6 h-6 rounded-full bg-purple-300/40 animate-pulse" />
    <div className="absolute -bottom-2 -right-2 w-8 h-8 rounded-full bg-blue-300/30 animate-pulse" />
    <div className="absolute top-1/2 -right-4 w-4 h-4 rounded-full bg-purple-200/50 animate-bounce" />

    <div className="relative rounded-3xl px-4 py-6 sm:px-8 sm:py-8">
 

      {/* Chat bubbles container */}
      <div className="space-y-6">
        {/* Student message */}
        <div className="flex items-start gap-3">
          {/* Student avatar with pulse animation */}
          <div className="relative flex-shrink-0">
            <div className="relative w-14 h-14 sm:w-16 sm:h-16">
              <div className="absolute inset-0 rounded-full bg-gradient-to-r from-purple-200 to-pink-200 animate-pulse" />
              <div className="absolute inset-1 rounded-full bg-white border-2 border-purple-300" />
              <img
                src={studentImg}
                alt="student"
                className="absolute inset-0 w-full h-full rounded-full p-1 object-cover"
              />
            </div>
            <div className="absolute -bottom-1 -right-1 w-5 h-5 rounded-full bg-purple-500 border-2 border-white flex items-center justify-center">
              <span className="text-xs text-white">🎓</span>
            </div>
          </div>

          {/* Student message bubble */}
          <div className="relative max-w-[70%]">
            <div className="relative px-4 py-3 rounded-2xl rounded-tl-none bg-white shadow-lg border border-purple-100">
              <p className="text-sm font-medium text-gray-800">
                Vijay Sir, what is yeole classes?
              </p>
              <div className="absolute -left-2 top-0 w-0 h-0 border-t-8 border-t-transparent border-r-8 border-r-white border-b-8 border-b-transparent" />
            </div>
          </div>
        </div>

        {/* Teacher message */}
        <div className="flex items-start justify-end gap-3">
          {/* Teacher message bubble */}
          <div className="relative max-w-[70%]">
            <div className="relative px-4 py-3 rounded-2xl rounded-tr-none bg-gradient-to-r from-purple-600 to-blue-600 shadow-lg">
              <p className="text-sm font-medium text-white">
                Yeole Classes is where students learn with love and grow with guidance.
              </p>
              <div className="absolute -right-2 top-0 w-0 h-0 border-t-8 border-t-transparent border-l-8 border-l-purple-600 border-b-8 border-b-transparent" />
            </div>
          
          </div>

          {/* Teacher avatar with pulse animation */}
          <div className="relative flex-shrink-0">
            <div className="relative w-14 h-14 sm:w-16 sm:h-16">
              <div className="absolute inset-0 rounded-full bg-gradient-to-r from-blue-200 to-cyan-200 animate-pulse" />
              <div className="absolute inset-1 rounded-full bg-white border-2 border-blue-300" />
              <img
                src={teacherImg}
                alt="teacher"
                className="absolute inset-0 w-full h-full rounded-full p-1 object-cover"
              />
            </div>
            <div className="absolute -bottom-1 -right-1 w-5 h-5 rounded-full bg-blue-500 border-2 border-white flex items-center justify-center">
              <span className="text-xs text-white">👨‍🏫</span>
            </div>
          </div>
        </div>

      </div>

     </div>
  </div>
</div>
</div>


      {/* Simple keyframes (global CSS or Tailwind config) */}
      {/* 
      @keyframes float {
        0%, 100% { transform: translateY(0px); }
        50% { transform: translateY(-10px); }
      }

      @keyframes fadeIn {
        from { opacity: 0; transform: translateY(4px); }
        to { opacity: 1; transform: translateY(0); }
      }
      */}
    </div>
  );
};

export default Hero;























